export default "__VITE_ASSET__b1afc7b4__"